import type { ProductTemplate } from "@cyh/contracts";

export function fuzzyProductTemplates(products: ProductTemplate[], query: string, limit = 20): ProductTemplate[] {
  const terms = query.trim().toLocaleLowerCase().split(/\s+/u).map(compactSearchText).filter(Boolean);
  if (!terms.length) return products.slice(0, limit);
  return products
    .map((product, index) => {
      const sku = compactSearchText(product.sku);
      const names = compactSearchText(`${product.name} ${product.nameEn}`);
      const searchable = `${sku} ${names}`;
      if (!terms.every((term) => searchable.includes(term))) return null;
      const score = terms.reduce((total, term) => total + (sku === term ? 100 : sku.startsWith(term) ? 60 : sku.includes(term) ? 40 : names.startsWith(term) ? 25 : 10), 0);
      return { product, index, score };
    })
    .filter((entry): entry is { product: ProductTemplate; index: number; score: number } => entry !== null)
    .sort((left, right) => right.score - left.score || left.index - right.index)
    .slice(0, limit)
    .map((entry) => entry.product);
}

function compactSearchText(value: string): string {
  return value.normalize("NFKC").toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, "");
}
